import { render, staticRenderFns } from "./SalePerCategory.vue?vue&type=template&id=1a28b048&"
import script from "./SalePerCategory.vue?vue&type=script&lang=js&"
export * from "./SalePerCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports